import { Routes, Route } from "react-router-dom";
import PrivateAuth from "../../authorization/PrivateAuth";
import CreateCustomer from "../../../pages/Customer/CustomerCreate/CreateCustomer";
import CustomerList from "../../../pages/Customer/CustomerList/CustomerList";

function CustomerRoute() {
  return (
    <Routes>
      <Route element={<PrivateAuth />}>
            {/* prefix customer */}

        <Route path="/create-customer" element={<CreateCustomer />} />
        <Route path="/list-customer" element={<CustomerList />} />


      </Route>
    </Routes>
  );
}

export default CustomerRoute;
